<script>
  // App icon with a grey placeholder showing the first letter while no icon exists for the app.
  export let src = "";
  export let name = "";

  let failed = false;
  // A new app (e.g. after editing the name) gets a new chance to load its icon
  $: src, (failed = false);
  $: initial = String(name || "").trim().charAt(0).toUpperCase() || "?";
</script>

{#if src && !failed}
  <img
    class="app-icon"
    {src}
    alt=""
    aria-hidden="true"
    on:error={() => (failed = true)}
  />
{:else}
  <span class="app-icon app-icon-placeholder" aria-hidden="true">{initial}</span>
{/if}

<style>
  .app-icon {
    flex: 0 0 1.5rem;
    width: 1.5rem;
    height: 1.5rem;
    object-fit: contain;
    border-radius: 0.25rem;
  }

  .app-icon-placeholder {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: var(--pax-smoke);
    color: var(--pax-grey);
    font-size: 0.75rem;
    font-weight: 600;
    line-height: 1;
  }
</style>
